import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    filterOutlets: [],
    filterTypes: [],
    lastQuery: null,
    paymentList: [],
};

const mutations = {
    setFilterOutlets(state, types) {
        state.filterOutlets = types;
    },

    setFilterTypes(state, types) {
        state.filterTypes = types;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },

    setPaymentList(state, data) {
        state.paymentList = data;
    },
};

const getters = {
    filterOutlets: state => {
        return state.filterOutlets;
    },

    filterTypes: state => {
        return state.filterTypes;
    },
};

const actions = {
    findPayments({ commit, dispatch }, params) {
        let options = {
            params: params,
        };

        let payments = state.paymentList.filter(p => {
            return params.ids.includes(p.id);
        });

        if (payments.length === params.ids.length) {
            return Promise.resolve(payments);
        }

        startLoading(dispatch, 'find-payments');

        return axios
            .get(Laroute.route('franchise.vue.payments'), options)
            .then(res => {
                endLoading(dispatch, 'find-payments');
                return res.data.data;
            })
            .catch(err => {
                endLoading(dispatch, 'find-payments');
                throw err;
            });
    },

    getPayment({ commit, dispatch }, id) {
        startLoading(dispatch, 'fetch-payment');

        return axios
            .get(Laroute.route('franchise.setting.payment.show', { id: id }))
            .then(res => {
                endLoading(dispatch, 'fetch-payment');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-payment');
                throw err;
            });
    },

    getPaymentList({ commit, dispatch }, params) {
        let options = { params };

        startLoading(dispatch, 'fetch-payment');

        return axios
            .get(Laroute.route('franchise.vue.payments'), options)
            .then(res => {
                let data = res.data.data;

                commit('setPaymentList', data);
                commit('setLastQuery', params.query);
                endLoading(dispatch, 'fetch-payment');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-payment');
                throw err;
            });
    },

    getPaymentBySource({ commit, dispatch }, source) {
        startLoading(dispatch, 'fetch-payment');

        return axios
            .get(
                Laroute.route('franchise.setting.payment.show.source', {
                    source: source,
                }),
            )
            .then(res => {
                endLoading(dispatch, 'fetch-payment');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-payment');
                throw err;
            });
    },

    getPaymentListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.paymentList.length || state.lastQuery !== params.query) {
            return dispatch('getPaymentList', params);
        }

        return Promise.resolve(state.paymentList);
    },

    createPayment({ commit, dispatch }, payment) {
        startLoading(dispatch, 'save-payment');

        return axios
            .post(Laroute.route('franchise.setting.payment.store'), payment)
            .then(res => {
                endLoading(dispatch, 'save-payment');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-payment');
                throw err;
            });
    },

    updatePayment({ commit, dispatch }, payment) {
        startLoading(dispatch, 'save-payment');

        return axios
            .patch(
                Laroute.route('franchise.setting.payment.update', {
                    id: payment.id,
                }),
                payment,
            )
            .then(res => {
                endLoading(dispatch, 'save-payment');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-payment');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/payment.js